import firebase from 'firebase'
require('firebase/firestore')

const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DB_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_BUCKET_URL,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID
}

firebase.initializeApp(config)

export const db = firebase.firestore()
const settings = { timestampsInSnapshots: true }
db.settings(settings)

export const ref = firebase.database().ref()
export const users = firebase.database().ref('users')
export const groups = firebase.database().ref('groups')
export const firebaseAuth = firebase.auth
export const firebaseauth = firebase.auth()
export const sto = firebase.storage()
export const database = firebase.database();


// WEBPACK FOOTER //
// ./src/config/firebaseconfig.js